import { render, staticRenderFns } from "./ModulePermissionList.vue?vue&type=template&id=1c3de2d6&scoped=true&"
import script from "./ModulePermissionList.vue?vue&type=script&lang=ts&"
export * from "./ModulePermissionList.vue?vue&type=script&lang=ts&"
import style0 from "./ModulePermissionList.vue?vue&type=style&index=0&id=1c3de2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3de2d6",
  null
  
)

export default component.exports